import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=77c8d9c4&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=77c8d9c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c8d9c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c8d9c4')) {
      api.createRecord('77c8d9c4', component.options)
    } else {
      api.reload('77c8d9c4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=77c8d9c4&scoped=true", function () {
      api.rerender('77c8d9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/detail.vue"
export default component.exports